#import "../fragments/peep-related-lead-fragment.graphql"
#import "../fragments/peep-related-lead-stats-fragment.graphql"

query GetPeepRelatedLeads($id: ID!) {
    peep(id: $id) {
        id
        type
        name
        description
        avatarUrl
        phones {
            primary {
                value {
                    id
                    numberFormatted
                }
            }
        }
        emailAddresses {
            primary {
                value {
                    display
                }
            }
        }
        postalAddresses {
            primary {
                value {
                    region
                }
            }
        }
        ... on Contact {
            jobTitle
        }
        leads(first: 100) {
            edges {
                node {
                    ...PeepRelatedLeadFragment
                }
            }
            stats {
                ...PeepRelatedLeadStatsFragment
            }
        }
    }
}
